export const buildInfo = {
  version: __APP_VERSION__,
  commit: __APP_COMMIT__,
  builtAt: __APP_BUILD_DATE__,
  repoUrl: __REPO_URL__,
  paypalUrl: __PAYPAL_URL__
};
